import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mode-notebook-cell-markdown',
  templateUrl: './notebook-cell-markdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookCellMarkdownComponent {
  @Input() markdown = '';
}
